<template>
  <div>
    <v-card width="6000">
      <v-card-title>
        <DialogTitle :dialogName="$options.name">
          Rates
        </DialogTitle>
      </v-card-title>
      <v-card-text>
        <v-data-table
          dense
          :items-per-page="10"
          :footer-props="{
            'show-first-last-page': true
          }"
          :headers="headers"
          :items="infoList"
          :loading="loading"
          class="elevation-1"
        >
          <template v-slot:item.IsDeleted="{ item }">
            <v-icon v-if="item.IsDeleted" color="error">
              {{ icon.lineItemIsDeleted }}
            </v-icon>
          </template>
          <template v-slot:item.Actions="{ item }">
            <v-icon small class="mr-2" @click="editItemClick(item)">
              {{ icon.lineItemEdit }}
            </v-icon>
            <v-icon small @click="deleteItemClick(item)">
              {{ icon.lineItemDelete }}
            </v-icon>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  small
                  color="blue"
                  class="ml-2"
                  @click="customerListClick(item)"
                >
                  {{ icon.customerList }}
                </v-icon>
              </template>
              <span>Customers using this rate</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <div class="table-footer-prepend d-flex pl-2 align-center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="newItemClick">
                <v-icon>{{ icon.lineItemAdd }}</v-icon>
              </v-btn>
            </template>
            <span>New Rate</span>
          </v-tooltip>
        </div>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showEditorDialog" width="800" persistent>
      <RateEditor
        :infoId="selectedItemId"
        :isDialogOpen="showEditorDialog"
        @close="editorCloseEvent"
        @update="editorUpdateEvent"
      />
    </v-dialog>

    <v-dialog v-model="showCustomerListDialog" width="600">
      <RateCustomerList
        :rateId="selectedItemId"
        :rateCode="selectedRateCode"
        :isDialogOpen="showCustomerListDialog"
        @close="rateCustomerListCloseEvent"
      />
    </v-dialog>
    <DialogUtil ref="dialogUtil" />
  </div>
</template>
<script>
import { ref, watch } from 'vue'
import { host } from '@/services/HostAPI'
import RateEditor from '@/components/Setup/Billing/RateEditor'
import RateCustomerList from '@/components/Setup/Billing/RateCustomerList'
import { icon } from '@/use/Constants'
export default {
  name: 'RateList',
  props: {
    isDialogOpen: {
      type: Boolean,
      default: false
    }
  },
  components: { RateEditor, RateCustomerList },
  setup(props, context) {
    const dialogUtil = ref(null)
    const loading = ref(false)

    watch(
      () => props.isDialogOpen,
      newVal => {
        newVal && initDialog()
      }
    )

    const initDialog = () => {
      infoList.value = []
      getRateList()
    }

    const infoList = ref([])
    const selectedItemId = ref(null)
    const selectedRateCode = ref(null)
    const showEditorDialog = ref(false)
    const showCustomerListDialog = ref(false)

    const getRateList = async () => {
      loading.value = true
      const rq = {}
      const rs = await host.rate.list(rq)
      infoList.value = rs.InfoList
      loading.value = false
    }

    function editItemClick(item) {
      selectedItemId.value = item.RateId
      showEditorDialog.value = true
    }

    function deleteItemClick(item) {
      dialogUtil.value
        .confirm({
          title: 'Please confirm',
          text: `Delete Rate ${item.Code}`
        })
        .then(() => performDeleteRate(item))
        .catch(() => {
          return
        })
    }

    async function performDeleteRate(item) {
      const rq = { InfoId: item.RateId }
      const rs = await host.rate.delete(rq)
      if (rs.IsSuccess) {
        getRateList()
      } else {
        dialogUtil.value.error(rs.Message)
      }
    }

    function newItemClick() {
      selectedItemId.value = null
      showEditorDialog.value = true
    }

    const headers = [
      { value: 'Code', text: 'Code', width: 100, align: 'left' },
      { value: 'Description', text: 'Description', width: 100, align: 'left' },
      { value: 'IsDeleted', text: 'Deleted', width: 20, align: 'center' },
      { value: 'Actions', text: 'Actions', sortable: false, width: 60 }
    ]

    const editorCloseEvent = () => {
      showEditorDialog.value = false
    }

    const editorUpdateEvent = () => {
      showEditorDialog.value = false
      getRateList()
    }

    const customerListClick = item => {
      selectedItemId.value = item.RateId
      selectedRateCode.value = item.Code
      showCustomerListDialog.value = true
    }

    const rateCustomerListCloseEvent = () => {
      showCustomerListDialog.value = false
      context.emit('close')
    }

    initDialog()

    return {
      dialogUtil,
      icon,
      infoList,
      headers,
      showEditorDialog,
      selectedItemId,
      editItemClick,
      deleteItemClick,
      newItemClick,
      editorCloseEvent,
      editorUpdateEvent,
      customerListClick,
      showCustomerListDialog,
      selectedRateCode,
      rateCustomerListCloseEvent,
      loading
    }
  }
}
</script>

<style lang="scss" scoped></style>
